import posthog from 'posthog-js'

export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY || ''
export const POSTHOG_HOST = 'https://us.i.posthog.com'

export const captureException = (error: unknown, additionalProperties?: Record<string, any>) => {
  // Skip empty/null/undefined errors — these are usually iOS Safari
  // AbortController.abort() or fetch cancellations, not real bugs.
  if (error == null) return;
  if (typeof error === 'string' && error.trim() === '') return;
  const errObj = error instanceof Error
    ? error
    : new Error(typeof error === 'string' ? error : JSON.stringify(error));
  // Drop if the resulting Error has no usable message (catches String('') case).
  if (!errObj.message || errObj.message === 'undefined' || errObj.message === 'null' || errObj.message === '{}') return;
  posthog.captureException(errObj, additionalProperties)
}

export { posthog }
